import { Node } from 'tiptap'
import { toggleBlockType } from 'tiptap-commands'

const namespace = 'ql-align'
export const QuoteStyles = [
  { name: 'Left', value: 'left' },
  { name: 'Right', value: 'right' },
  { name: 'Centered', value: 'center' },
  { name: 'Plain', value: 'justify' },
  { name: 'Bomb', value: 'bomb' },
]
export class Quote extends Node {
  get name() {
    return 'quote'
  }

  get defaultOptions() {
    return {
      styles: QuoteStyles,
    }
  }

  get schema() {
    return {
      attrs: {
        style: {
          default: 'left',
        },
      },
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: this.options.styles.map((item) => ({
        tag: `blockquote[class="${namespace}-${item.value}"]`,
        attrs: { style: item.value },
      })),
      toDOM: (node) => ['blockquote', { class: `${namespace}-${node.attrs.style}` }, ['span', {}, 0]],
    }
  }

  commands({ type, schema }) {
    return (attrs) => toggleBlockType(type, schema.nodes.paragraph, attrs)
  }
}
